<template>
  <div class="ren-decoration-cp ren-decoration-cp-action-card">
    <div>
      <strong>{{ title }}</strong>
      <span>{{ subtitle }}</span>
    </div>
    <button v-if="showLocation" type="button">定位</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const title = computed(() => stringValue(props.component.props?.title, '服务地图'))
const subtitle = computed(() => {
  const city = stringValue(props.component.props?.defaultCity, '当前城市')
  return stringValue(props.component.props?.emptyText, `${city} · 地图与周边生活`)
})
const showLocation = computed(() => booleanValue(props.component.props?.showLocation, true))
</script>
